import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CollapseContainer,
  CollapseContent,
  CollapseHeader,
  CollapseIcon,
  CollapseTitle,
} from './styles';

interface CollapseProps {
  title: string;
  children: React.ReactNode;
  comingSoon?: boolean
}

export const Collapse = ({ title, children }: Readonly<CollapseProps>) => {
  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation();

  return (
    <CollapseContainer>
      <CollapseHeader onClick={() => setIsOpen((p) => !p)}>
        <CollapseTitle>{title}</CollapseTitle>
        <CollapseIcon $isopen={isOpen} />
      </CollapseHeader>
      <CollapseContent $isopen={isOpen}>
        {children}
      </CollapseContent>
    </CollapseContainer>
  );
};
